import type { CalendarGridMinutes, CalendarView } from "../_shared/_logic/display-scale"

export type CalendarPreferences = { view: CalendarView; gridMinutes: CalendarGridMinutes }
export const DEFAULT_CALENDAR_PREFERENCES: CalendarPreferences = {
  view: "overview",
  gridMinutes: 15,
}
type StoredCalendarPreferences = Pick<CalendarPreferences, "view">
const sessionPreferences = new Map<string, StoredCalendarPreferences>()
export const calendarPreferenceKey = (organizationId: string, userId: string) =>
  `kehrblatt:calendar:v1:${encodeURIComponent(organizationId)}:${encodeURIComponent(userId)}`

export const readCalendarPreferences = (
  key: string,
  storage?: Pick<Storage, "getItem">,
): CalendarPreferences => {
  let saved: Partial<StoredCalendarPreferences> | null = sessionPreferences.get(key) ?? null
  try {
    saved = JSON.parse(storage?.getItem(key) ?? "null") ?? saved
  } catch {
    /* Browser storage may be unavailable. */
  }

  return {
    view:
      saved?.view === "timeline" || saved?.view === "overview"
        ? saved.view
        : DEFAULT_CALENDAR_PREFERENCES.view,
    gridMinutes: DEFAULT_CALENDAR_PREFERENCES.gridMinutes,
  }
}

export const saveCalendarPreferences = (
  key: string,
  value: CalendarPreferences,
  storage?: Pick<Storage, "setItem">,
) => {
  const saved: StoredCalendarPreferences = { view: value.view }
  sessionPreferences.set(key, saved)
  try {
    storage?.setItem(key, JSON.stringify(saved))
  } catch {
    /* Retain in memory for this session. */
  }
}

export const browserCalendarStorage = (): Storage | undefined => {
  try {
    return typeof window === "undefined" ? undefined : window.localStorage
  } catch {
    return undefined
  }
}
